import type { QueryKey, UseQueryResult, UseQueryOptions, QueryOptions } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import client from "@/api/client/axios";
import type { GetFederalDistrictsQueryResponse, GetFederalDistricts400, GetFederalDistricts500 } from "../types/GetFederalDistricts";

export const getFederalDistrictsQueryKey = () =>     [{url:`/api/regions/federal-districts`}] as const;
      export function getFederalDistrictsQueryOptions <TData = GetFederalDistrictsQueryResponse, TError = GetFederalDistricts400 | GetFederalDistricts500>(options: Partial<Parameters<typeof client>[0]> = {}): UseQueryOptions<TData, TError> {
        const queryKey = getFederalDistrictsQueryKey();

        return {
          queryKey,
          queryFn: () => {
            
            return client<TData, TError>({
              method: "get",
              url: `/api/regions/federal-districts`,
              
              
              ...options,
            }).then(res => res.data);
          },
        };
      };
      
/**
 * @summary Получение федеральных округов
 * @link /api/regions/federal-districts
 */

export function useGetFederalDistricts <TData = GetFederalDistrictsQueryResponse, TError = GetFederalDistricts400 | GetFederalDistricts500>(options: {
          query?: UseQueryOptions<TData, TError>,
          client?: Partial<Parameters<typeof client<TData, TError>>[0]>,
        } = {}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const { query: queryOptions, client: clientOptions = {} } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getFederalDistrictsQueryKey();

  const query = useQuery<TData, TError>({
    ...getFederalDistrictsQueryOptions<TData, TError>(clientOptions),
    ...queryOptions
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey as QueryKey;

  return query;
};
